import { render, staticRenderFns } from "./deleteReserveDining.vue?vue&type=template&id=26f6f1e2&scoped=true"
import script from "./deleteReserveDining.vue?vue&type=script&lang=js"
export * from "./deleteReserveDining.vue?vue&type=script&lang=js"
import style0 from "./deleteReserveDining.vue?vue&type=style&index=0&id=26f6f1e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26f6f1e2",
  null
  
)

export default component.exports